<div *ngFor="let ae of activity.model.activityEntities">
  <div *ngIf="!ae.hasEntities">You must complete the <b>{{ ae.activityName }}</b> Activity before continuing. Click Next to go to the <b>{{ ae.activityName }}</b> Activity.</div>
  <div *ngIf="ae.hasEntities && ae.dataEntities.length == 0">You must switch the View As Role to <b>{{ ae.responsibleRoleName }}</b> to see the Data Entities to enter on <b>{{ ae.activityName }}</b>.</div>
  <div *ngIf="ae.dataEntities && ae.dataEntities.length > 0">You must complete the following Data Entities from the <b>{{ ae.activityName }}</b> Activity before continuing.</div>
  <ng-container *ngIf="form && form.controls[ae.activityId]">
    <div class="switch" [formGroup]="form.controls[ae.activityId + '-skip']" *ngIf="ae.canSkipActivity && (!ae.hasEntities || ae.dataEntities.length > 0)">
      <label>
        <input
          type="checkbox"
          formControlName="skipActivity"
          [(ngModel)]="ae.skipActivity"
          (ngModelChange)="skipActivity(ae)"
        />
        Skip Activity?
      </label>
    </div>
    <div *ngIf="ae.skipActivity" class="text-danger">You are choosing to proceed with this application as if the routing did not take the user to this activity. Proceed with caution, this may cause behavior that may not occur in a live application.</div>
    <wm-data-entity-input
      *ngFor="let de of ae.dataEntities"
      [entity]="de"
      [form]="form.controls[ae.activityId]"
      [applicationId]="applicationId"
    ></wm-data-entity-input>
  </ng-container>
</div>
